import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { HtmlEmail } from 'components/html_email';
import { useLinkDomainData } from 'hooks/analytics_events';
import { useTrackBookingPageShared } from 'hooks/analytics_events/useTrackBookingPageShared';
import { useEventTypeLocation } from 'hooks/useEventTypeLocation';
import { ClipboardButton } from '../clipboard_button';
import { eventTypeSelector, timezoneSelector, groupedSpotsSelector } from '../selectors';
const styledClipboardButtonCss = "s14fgnyx";
const StyledClipboardButton = forwardRef((props, ref) => {
  const responsive = false;
  const decoration = 'outline';
  const successStyle = 'success';
  const successMessage = I18n.t('publisher.event_types.context.copied');
  const size = useDeviceType('isPhone') ? 'small' : 'normal';
  return <ClipboardButton ref={ref} {...props} responsive={responsive} decoration={decoration} successStyle={successStyle} successMessage={successMessage} size={size} className={classNames(styledClipboardButtonCss, props.className)} />;
});
const initialStateCss = "i1ypp2t9";
const InitialState = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(initialStateCss, props.className)} />;
});
export const CopyTimesButton = () => {
  const eventType = useSelector(eventTypeSelector);
  const timezone = useSelector(timezoneSelector);
  const groupedSpots = useSelector(groupedSpotsSelector);
  const domainProps = useLinkDomainData(eventType.bookingUrl);
  const locationType = useEventTypeLocation(eventType);
  const trackBookingPageShared = useTrackBookingPageShared(eventType.id);
  const sendBookingPageShared = () => {
    trackBookingPageShared({
      location_type: locationType || null,
      event_type_name: eventType.name,
      share_object: 'event_type',
      share_object_id: eventType.id.toString(),
      share_object_uuid: eventType.uuid,
      share_method: 'add_times_to_email',
      share_location: 'et_card',
      share_modal_source: 'adhoc_creation',
      is_single_use: false,
      is_customized_at_share: true,
      ...domainProps
    });
  };
  return <StyledClipboardButton content={<HtmlEmail bookingUrl={eventType.bookingUrl} eventType={eventType} timezone={timezone} groupedSpots={groupedSpots} isOneOff />} onClick={sendBookingPageShared}>
      <InitialState>
        {I18n.t('publisher.event_types.one_off_share_modal.one_off.email_preview.copy_times')}
      </InitialState>
    </StyledClipboardButton>;
};

require("./copy_times_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./copy_times_button.js");